import axios from "axios";

// [YOMA] - [ID-50650] - (Collections to Approval Redirect Issue) - (21-11-2022)
const { REACT_APP_BASE_URL, REACT_APP_EID } = process.env;
const headerOutToken = { 'e-id': REACT_APP_EID, 'refresh-token': localStorage.getItem('_rc'), 'token': localStorage.getItem('_ac') };

const client = axios.create({ baseURL: REACT_APP_BASE_URL });

const refreshToken = () => {
    axios.get('refresh-token', { headers: headerOutToken }).then(res => {
        localStorage.setItem('_ac', res?.data?.data?.access_token);
        window.location.reload();
    });

}

export const request = ({ ...options }) => {
    // [YOMA] - [ID-50650] - (Collections to Approval Redirect Issue) - (21-11-2022)
    client.defaults.headers.common['e-id'] = REACT_APP_EID;
    client.defaults.headers.common['token'] = localStorage.getItem('_ac') !== null ? localStorage.getItem('_ac') : '';
    const onSuccess = response => response
    const onError = error => {
        error.response.status === 401 && refreshToken();
        return error.response
    }
    return client(options).then(onSuccess).catch(onError)
}